import ApiService from '@apis/api-service'
import { API_PATHS } from '@constants/paths'

const login = (email) => ApiService.post(API_PATHS.auth.login, { email })
const logout = () => ApiService.post(API_PATHS.auth.logout)

const AuthApiService = { login, logout }

export default AuthApiService
